import React from "react";
import '../style/OrderAProject.css';
import { Link } from 'react-router-dom';
export default function OrderAProject() {

    return (
        <>

            <section className="section-6">
                <div className="sec-6">
                    <img className="primg" src={require("../img/10.png")} alt="Error" />
                    <a className="a_h" href="/"> <i class="fa-solid fa-arrow-left me-3"></i>  Go to Home page</a>
                    <h1 className="text-center mt-5">Order a project</h1>
                    <div className="input-title mt-5 d-flex justify-content-between">
                        <p className="input_p">Title</p>
                        <p className="input_pt">0/80</p>
                    </div>
                    <input type="text" class="form-control input1" placeholder="Type here" />
                    <div className="input-description mt-5 d-flex justify-content-between">
                        <p>Description</p>
                    </div>
                    <input type="text" className="input2  form-control" placeholder="Type here" />




                    <div className="box-6 d-flex justify-content-between ">
                        <div className="box-6_left">
                            <h4 className="ms-3">3D skills</h4>
                            <div className="boxbox-6_l p-3">
                                <div className="box-nav  d-flex  ">
                                    <p className="lead me-5 ">Select 3D skills</p>
                                    <p className="text-secondary ">1 selected</p>
                                    <div className="drop" >
                                        <i class="fa-solid fa-angle-up ms-5 mb-2"></i>
                                    </div>
                                </div>
                                <hr className="" />
                                <div className="box-menu d-flex justify-content-between">
                                    <div className="box-m-1">
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Modelling</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Print Modelling</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Scanning</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Animating</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Lighting</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Low Poly Modelling</p>
                                        </div>
                                    </div>
                                    <div className="box-m-2">
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Particles</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">PBR Modelling</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Rendering</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Rigging</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Shaders</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Skinning</p>
                                        </div>
                                    </div>
                                    <div className="box-m-3">
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Texturing</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">UV Mapping</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box-6_left">
                            <h4 className="ms-3">3D software</h4>
                            <div className="boxbox-6_l p-3">
                                <div className="box-nav  d-flex  ">
                                    <p className="lead me-5 ">Select 3D skills</p>
                                    <p className="text-secondary ">1 selected</p>
                                    <i class="fa-solid fa-angle-up ms-5 mb-2"></i>
                                </div>
                                <hr className="" />
                                <div className="box-menu d-flex ">
                                    <div className="box-m-1">
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Modelling</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Print Modelling</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3D Scanning</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Animating</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Lighting</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Low Poly Modelling</p>
                                        </div>
                                    </div>
                                    <div className="box-m-2 ms-5">
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">Lumion</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">GrowFX</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">3Ds Max Material Library</p>
                                        </div>
                                        <div className="inputgr d-flex">
                                            <input type="checkbox" className="input-4 form-check-input " />
                                            <p className="ps-3">PDF</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="d">
                    <div className="in  ">
                        <div className="in_l">
                            <h1 className="display-6">Deadline</h1>
                            <div className="ingr d-flex">
                                <input type="date" className="indate form-control" />
                                <input type="checkbox" className="incheck " />
                                <p className="pt-3">No fixed deadline</p>
                            </div>
                        </div>
                        <div className="in_r ">
                            <h1 className="display-6">Budget</h1>
                            <div class="input-group flex-nowrap ">
                                <span class="input-group-text" >$</span>
                                <input type="number" className="form-control innumber "  />
                            </div>
                        </div>
                    </div>
                    </div>
                    <button className="btn btn-6 btn-6_1">Cancel</button>
                    <Link className="lin btn btn-6" to="/project">Start a project</Link>
                </div>
                
            </section >
            <footer className="fOrder">
                <div className="foot ">
                    <h1 className="mt-5 fw-bold  pt-5">Biz bilan hamkor bo’ling</h1>
                    <p className="text-secondary lead">Biz sifatli va ajoyib modellarni sizga taqdim qilamiz</p>
                    <div className="l">
                        <Link className="but mt-5" to="/order">Order A Project</Link>
                    </div>
                </div>
                <div className="foot-  d-flex justify-content-between">
                    <img src={require("../dizipro.png")} alt="Error" />
                    <div className="nav-menu">
                        <Link className="nav-item text-light  " to="/">Home</Link>
                        <Link className="nav-item text-light  " to="/portfolio">Portfolio</Link>
                        <Link className="nav-item text-light  " to="/order">Order A Project</Link>
                        <Link className="nav-item text-light  " to="/paid">Paid Courses</Link>
                        <Link className="nav-item text-light  " to="/profil">Profil</Link>
                    </div>
                    <div className="i">
                        <i class="fa-brands fa-instagram"></i>
                        <i class="fa-brands fa-telegram"></i>
                        <i class="fa-brands fa-facebook"></i>
                    </div>
                </div>
            </footer>
        </>
    )
}